import { NATTER_EXPLAINER_VIDEO } from 'common/constants';

import { type GetNatterDetailApiResponse, type Natter } from './types';

export const mapNatterDetailFromApi = ({
  id,
  ownerId,
  ownerName,
  communityId,
  name,
  description,
  topic,
  slotDurationMinutes,
  availableSlots,
  selectedSlots,
  status,
  videoUrl,
}: GetNatterDetailApiResponse): Natter => ({
  id,
  ownerId,
  ownerName,
  communityId: Number(communityId),
  name,
  description,
  topic,
  slotDurationMinutes,
  availableSlots,
  selectedSlots,
  status,
  /**
   * Short term workaround:
   *   if videoUrl equals the guidance video, we have only 1 video, the default guidance one
   *   else we have 2 videos
   */
  videos: videoUrl === NATTER_EXPLAINER_VIDEO ? [videoUrl] : [videoUrl, NATTER_EXPLAINER_VIDEO],
});
